<template>
    <div id="notificationCenter">
        <transition-group name="notification-list">
            <notification v-for="(n,k) in notifications" :notification="n" :key="k" />
        </transition-group>
    </div>
</template>


<script>

import EventBus from '../../services/EventBus'; 
import Notification from "./Notification.vue";

export default {
    name: 'NotificationCenter',
    data(){
        return {
            notifications: [],
            displayTime: 5000,
            messengerMessagesCount: 0
        }
    },
    mounted(){
        EventBus.$on('error', (message)=>{
            this.addNotification('error', message)
        });
        EventBus.$on('success', (message)=>{
            this.addNotification('success', message)
        });
        EventBus.$on('warning', (message)=>{
            this.addNotification('warning', message)
        });

        EventBus.$on('user.login', ()=>{
            this.loadMessengerMessageCount();
        });
        EventBus.$on('messenger.reloadMessageCount', ()=>{
            this.loadMessengerMessageCount();
        });

    },
    sockets: {
        receiveMessage(message){

            if(this.$route.name !== 'MessengerDetail'
              && !this.$route.params.conversationId
              && this.$route.params.conversationId !== message.conversation
            ){
              this.messengerMessagesCount++;
              this.$store.commit('user/setUnreadMessages', this.messengerMessagesCount)
            }

        }
    },
    methods: {
        addNotification(type, message){
            const note = {type, message};
            this.notifications.push(note);

            setTimeout(()=>{
                this.notifications = this.notifications.filter((item)=>(item!=note));
            }, this.displayTime);
        },
        loadMessengerMessageCount(){
            this.$api.getUnreadMessages()
                .then((res)=>{
                  this.messengerMessagesCount = res.data.unreadMessages;
                  this.$store.commit('user/setUnreadMessages', this.messengerMessagesCount)
                });
        },

    },
    components: {
        notification: Notification
    }
}
</script>

<style lang="sass">

    @import '../../assets/sass/vars.scss'

    #notificationCenter
        position: fixed
        bottom: 1em
        right: 1em
        padding: 0
        width: 320px
        max-height: 80%
        overflow: hidden
        z-index: $z-notificationCenter

    .notification-list-enter-active,
    .notification-list-leave-active,
    .notification-list-move
        transition: all .3s

    .notification-list-enter,
    .notification-list-leave-to
        opacity: 0


    .notification-list-enter
        transform: translateX(100%)

    .notification-list-leave-active
        //position: absolute

</style>



// WEBPACK FOOTER //
// src/components/layout/NotificationCenter.vue